import { jwtMessageAsGetReturnsJson } from "../jwtcomm";
const apiVersion = process.env.API_VERSION || "1.0";
export async function getClientInfo(authToken, clientId) {
    return await jwtMessageAsGetReturnsJson("get", `/api/${apiVersion}/mpc/client`, authToken, {
        clientId,
    });
}
